/* eslint-disable camelcase */
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { eventService } from '../../../services/event.service'
import './style.scss'
// import * as bootstrap from 'bootstrap'

export const CardEventDashboard = (props) => {
  const {
    fecha_creado,
    descripcion,
    ubicacion,
    nombre,
    nombre_organizador,
    foto_portada,
    id_evento,
    precio,
    boletos_vendidos,
    setFetched,
    fetch,
    fromPublicados,
    fromEliminados,
    fromAprobados
  } = props

  // useEffect(() => {
  //   const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
  //   const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
  //   console.log(popoverList)
  //   return () => {
  //     console.log(popoverList)
  //   }
  // }, [])

  // ¿Qué hace eso de arriba?

  const handlerAproveEvent = async (e) => {
    try {
      console.log(fromPublicados)
      await eventService.aproveEvent(id_evento)
      setFetched(() => !fetch)
    } catch (error) {
      alert('error')
      console.log(error)
    }
  }
  const handlerRejectEvent = async () => {
    try {
      await eventService.rejectEvent(id_evento)
      setFetched(() => !fetch)
    } catch (error) {
      alert('error')
      console.log(error)
    }
  }
  const handlerRemoveEvent = async () => {
    try {
      await eventService.removeEvent(id_evento)
      setFetched(() => !fetch)
    } catch (error) {
      alert('error')
      console.log(error)
    }
  }

  return (
    <section>
      <div className="card border-card card-event-dashboard bg-black text-light">
        <div>
          <div className="img-wrapper zoom">
          <img src={foto_portada} className="card-img-top" alt={nombre} />
          </div>
          <div className="card-body card-event-body">
          <h5
            className="card-title text-light mb-0">
            {nombre}
          </h5>
          <div className="card-event-data">
            <p className="d-flex align-items-center fw-bold text-decoration-none mt-1 mb-n2">{fecha_creado}</p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              {ubicacion}
            </p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              Precio: {precio} MXN
            </p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              Boletos Vendidos: {boletos_vendidos} MXN
            </p>
            <p
              className="d-flex
              align-items-center fw-bold text-decoration-none mt-1 mb-n2"
             >
              Descripción: {descripcion}
            </p>
          </div>
        </div>
        </div>
      </div>
      <div className="card-actions ">
            <Link
              to={`/dashboard/aprobar/eventos/${id_evento}`}
              className="btn btn-info btn-sm"
            >
              <i className="bx bx-info-square fs-lg" />
            </Link>

            <button onClick={handlerAproveEvent} disabled={fromPublicados} className="btn btn-success btn-sm">
              <i className="bx bx-like fs-lg" />
            </button>

            <button onClick={handlerRejectEvent} disabled={fromAprobados} className="btn btn-warning btn-sm">
              <i className="bx bx-dislike fs-lg" />
            </button>

            <button onClick={handlerRemoveEvent} disabled={fromEliminados} className="btn btn-danger btn-sm">
              <i className="bx bx-trash fs-lg" />
            </button>
          </div>
    </section>
  )
}
